import { shallowRef, onBeforeUpdate } from "vue";
const useObjectRefs = () => {
  const itemRefs = shallowRef({});
  const setItemRef = (key) => (el) => {
    if (!el) {
      return;
    }
    itemRefs.value[key] = el;
    return String(key);
  };
  onBeforeUpdate(() => {
    itemRefs.value = {};
  });
  return { itemRefs, setItemRef };
};
export {
  useObjectRefs as u
};
//# sourceMappingURL=useObjectRefs.js.map
